
define('template!pimSearchCompareColumnTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="pim-compare-col-card">\n\n    <div class="pim-compare-col-header">\n        <button class="pim-compare-col-remove js-col-remove" title="' +
((__t = ( _.i18n('common.remove', null, 'Remove') )) == null ? '' : __t) +
'">×</button>\n        <a class="pim-compare-col-thumb" href="#pim/products/' +
((__t = ( productId )) == null ? '' : __t) +
'" title="' +
((__t = ( _.i18n('compare.openDetails', null, 'Open product details') )) == null ? '' : __t) +
'">\n            <img src="' +
((__t = ( img )) == null ? '' : __t) +
'" alt="" />\n        </a>\n        <div class="pim-compare-col-name" title="' +
((__t = ( productName )) == null ? '' : __t) +
'">' +
((__t = ( productName )) == null ? '' : __t) +
'</div>\n        <div class="pim-compare-col-meta">\n            ';
 if (productCode) { ;
__p += '<span class="pim-compare-col-code">' +
((__t = ( productCode )) == null ? '' : __t) +
'</span>';
 } ;
__p += '\n            ';
 if (supplierName) { ;
__p += '<span class="pim-compare-col-supplier">' +
((__t = ( supplierName )) == null ? '' : __t) +
'</span>';
 } ;
__p += '\n        </div>\n    </div>\n\n    <div class="pim-compare-col-stock js-col-stock" style="display: none;">\n        <i class="fa fa-cubes pim-compare-col-stock-icon"></i>\n        <span class="pim-compare-col-stock-total js-col-stock-total">—</span>\n        <span class="pim-compare-col-stock-breakdown js-col-stock-breakdown"></span>\n    </div>\n\n    <div class="pim-compare-col-result">\n        <div class="pim-compare-col-empty js-col-empty">' +
((__t = ( _.i18n('compare.notCalculated', null, 'Pick options then calculate') )) == null ? '' : __t) +
'</div>\n        <div class="pim-compare-col-total">\n            <span class="pim-compare-col-total-label">' +
((__t = ( _.i18n('price.total', null, 'Total') )) == null ? '' : __t) +
'</span>\n            <span class="pim-compare-col-total-value js-col-total">—</span>\n        </div>\n        <div class="pim-compare-col-unit js-col-unit">—</div>\n        <div class="pim-compare-col-margin">\n            <span class="pim-compare-col-margin-label">' +
((__t = ( _.i18n('price.marginPrice', null, 'Margin') )) == null ? '' : __t) +
':</span>\n            <span class="js-col-margin">—</span>\n        </div>\n        <div class="pim-compare-col-breakdown js-col-breakdown"></div>\n\n        <button class="btn btn-success btn-sm pim-compare-col-offer js-col-create-offer">\n            <i class="fa fa-file-text-o"></i>\n            ' +
((__t = ( _.i18n('compare.createOffer', null, 'Create offer') )) == null ? '' : __t) +
'\n        </button>\n    </div>\n\n    <div class="pim-compare-col-config">\n        <div class="pim-compare-col-section-title">' +
((__t = ( _.i18n('common.configuration', null, 'Configuration') )) == null ? '' : __t) +
'</div>\n\n        <div class="pf-fc-field">\n            <label class="pf-fc-label">' +
((__t = ( _.i18n('common.quantity', null, 'Quantity') )) == null ? '' : __t) +
'</label>\n            <input type="number" min="1" class="pf-fc-input js-col-qty" value="' +
((__t = ( quantity )) == null ? '' : __t) +
'" />\n        </div>\n\n        ';
 if (printAreas.length > 0) { ;
__p += '\n            <div class="pim-compare-col-subtitle">' +
((__t = ( _.i18n('print.imprint', null, 'Imprint') )) == null ? '' : __t) +
'</div>\n        ';
 } ;
__p += '\n\n        ';
 for (var i = 0; i < printAreas.length; i++) { ;
__p += '\n            <div class="pf-fc-field">\n                <label class="pf-fc-label">' +
((__t = ( printAreas[i].name )) == null ? '' : __t) +
'</label>\n                <div class="dropdown pf-fc-dropdown">\n                    <button class="pf-fc-dropdown-btn dropdown-toggle" type="button"\n                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                        <span class="pf-fc-dropdown-label printzone-' +
((__t = ( i )) == null ? '' : __t) +
'-label">' +
((__t = ( _.i18n('common.none', null, 'None') )) == null ? '' : __t) +
'</span>\n                        <span class="pf-fc-dropdown-caret"></span>\n                    </button>\n                    <ul class="dropdown-menu dropdown-menu-printzone" role="menu">\n                        <li><a data-index="' +
((__t = ( i )) == null ? '' : __t) +
'" data-pz-id="-1" href="#">' +
((__t = ( _.i18n('common.none', null, 'None') )) == null ? '' : __t) +
'</a></li>\n                        ';
 for (var j = 0; j < printAreas[i].printZones.length; j++) { ;
__p += '\n                            ';
 var pz = printAreas[i].printZones[j]; ;
__p += '\n                            ';
 if (pz.colorModeType === 'spot') { ;
__p += '\n                                ';
 for (var k = 1; k <= pz.maxColors; k++) { ;
__p += '\n                                    <li><a data-index="' +
((__t = ( i )) == null ? '' : __t) +
'" data-nb-color="' +
((__t = ( k )) == null ? '' : __t) +
'" data-pz-id="' +
((__t = ( pz.id )) == null ? '' : __t) +
'" href="#">' +
((__t = ( pz.name )) == null ? '' : __t) +
' · ' +
((__t = ( k )) == null ? '' : __t) +
'C · ' +
((__t = ( pz.width )) == null ? '' : __t) +
'×' +
((__t = ( pz.height )) == null ? '' : __t) +
' ' +
((__t = ( printAreas[i].unit )) == null ? '' : __t) +
'</a></li>\n                                ';
 } ;
__p += '\n                            ';
 } else { ;
__p += '\n                                <li><a data-index="' +
((__t = ( i )) == null ? '' : __t) +
'" data-nb-color="1" data-pz-id="' +
((__t = ( pz.id )) == null ? '' : __t) +
'" href="#">' +
((__t = ( pz.name )) == null ? '' : __t) +
' · ' +
((__t = ( pz.width )) == null ? '' : __t) +
'×' +
((__t = ( pz.height )) == null ? '' : __t) +
' ' +
((__t = ( printAreas[i].unit )) == null ? '' : __t) +
'</a></li>\n                            ';
 } ;
__p += '\n                        ';
 } ;
__p += '\n                    </ul>\n                </div>\n            </div>\n        ';
 } ;
__p += '\n\n        ';
 if (productOptionCategories.length > 0) { ;
__p += '\n            <div class="pim-compare-col-subtitle">' +
((__t = ( _.i18n('product.options', null, 'Options') )) == null ? '' : __t) +
'</div>\n        ';
 } ;
__p += '\n\n        ';
 for (var i = 0; i < productOptionCategories.length; i++) { ;
__p += '\n            <div class="pf-fc-field">\n                <label class="pf-fc-label">' +
((__t = ( productOptionCategories[i].name )) == null ? '' : __t) +
'</label>\n                <div class="dropdown pf-fc-dropdown">\n                    <button class="pf-fc-dropdown-btn dropdown-toggle" type="button"\n                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                        <span class="pf-fc-dropdown-label option-' +
((__t = ( i )) == null ? '' : __t) +
'-label">' +
((__t = ( _.i18n('common.none', null, 'None') )) == null ? '' : __t) +
'</span>\n                        <span class="pf-fc-dropdown-caret"></span>\n                    </button>\n                    <ul class="dropdown-menu dropdown-menu-option" role="menu">\n                        ';
 for (var j = 0; j < productOptionCategories[i].productOptions.length; j++) { ;
__p += '\n                            <li><a data-index="' +
((__t = ( i )) == null ? '' : __t) +
'" data-option-id="' +
((__t = ( productOptionCategories[i].productOptions[j].id )) == null ? '' : __t) +
'" href="#">' +
((__t = ( productOptionCategories[i].productOptions[j].name )) == null ? '' : __t) +
'</a></li>\n                        ';
 } ;
__p += '\n                    </ul>\n                </div>\n            </div>\n        ';
 } ;
__p += '\n\n        <button class="btn btn-primary btn-sm pim-compare-col-calc js-col-calc">\n            ' +
((__t = ( _.i18n('common.calculate', null, 'Calculate') )) == null ? '' : __t) +
'\n        </button>\n    </div>\n\n    <div class="loading-block js-col-loading loader" style="display: none;"></div>\n</div>\n';

}
return __p
};});

